import { RastreamentoController } from './rastreamento.controller';
import { RastreamentoDetalhesReversaComponent } from './rastreamento-detalhes-reversa/rastreamento-detalhes-reversa.component';
import { RastreamentoDetalhesComponent } from './rastreamento-detalhes/rastreamento-detalhes.component';

'use strict';

angular.module('mandaeApp')
  .config(function ($stateProvider) {
    $stateProvider
      // url will be pedido/rastreamento/123
      .state('rastreamento', {
        url: '/rastreamento/{numeroRastreio:[0-9A-Z_a-z-]{1,100}}',
        template: require('./rastreamento.html'),
        controller: RastreamentoController,
        controllerAs: 'vm',
        data: {
          pageTitle: 'Mandaê | Rastrear sua encomenda'
        }
      });
  })
  .component('appRastreamentoDetalhes', RastreamentoDetalhesComponent)
  .component('appRastreamentoDetalhesReversa', RastreamentoDetalhesReversaComponent);;
